import { render, staticRenderFns } from "./MultiCheckbox.vue?vue&type=template&id=e9236cb6&"
import script from "./MultiCheckbox.vue?vue&type=script&lang=js&"
export * from "./MultiCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports